module.exports = __webpack_public_path__ + "static/media/undraw_lost_bqr2.316419f6.svg";